/** Alinha à otimização do backend (`ai_stock_downscale_image`: max 1600, JPEG ~82). */
const MAX_EDGE = 1600;
const JPEG_QUALITY = 0.82;

function loadImageFromFile(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Não foi possível ler a imagem."));
    };
    img.src = url;
  });
}

/**
 * Reduz a imagem antes do upload (mesmos limites do servidor).
 * Se já estiver dentro do limite e for JPEG pequeno, devolve o arquivo original.
 */
export async function optimizeAiStockImage(file: File): Promise<File> {
  if (!file.type.startsWith("image/")) return file;

  const img = await loadImageFromFile(file);
  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;
  if (!w || !h) return file;

  const scale = Math.min(1, MAX_EDGE / Math.max(w, h));
  const alreadySmallJpeg =
    scale >= 1 && file.type === "image/jpeg" && file.size <= 1_200_000;
  if (alreadySmallJpeg) return file;

  const nw = Math.max(1, Math.round(w * scale));
  const nh = Math.max(1, Math.round(h * scale));
  const canvas = document.createElement("canvas");
  canvas.width = nw;
  canvas.height = nh;
  const ctx = canvas.getContext("2d");
  if (!ctx) return file;
  ctx.drawImage(img, 0, 0, nw, nh);

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY),
  );
  if (!blob || blob.size === 0) return file;
  // Se a otimização ficou maior (raro), mantém o original.
  if (blob.size >= file.size && scale >= 1) return file;

  const base = file.name.replace(/\.[^.]+$/, "") || "nota";
  return new File([blob], `${base}.jpg`, { type: "image/jpeg", lastModified: Date.now() });
}

export function aiStockDevTime(label: string, startedAt: number, extra?: Record<string, unknown>) {
  if (!import.meta.env.DEV) return;
  const ms = Math.round(performance.now() - startedAt);
  // eslint-disable-next-line no-console
  console.info(`[ai-stock] ${label}: ${ms}ms`, extra ?? "");
}
